//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layer from '@/components/layer/layer.vue'
import Frame from './frame'

export default {
  data() {
    return {
      headSrc:{ // 弹框头像
        'err':'https://static.soyoung.com/sy-pre/head_err-1596093000745.png',
        'right':'https://static.soyoung.com/sy-pre/head_right-1596093000745.png',
        'end':'https://static.soyoung.com/sy-pre/head_right-1596093000745.png',
        'noLife':'https://static.soyoung.com/sy-pre/head_life-1596093000745.png'
      },
      value:'--', //提示框内容
      iconSrc:'https://static.soyoung.com/sy-pre/err-1596089400713.png',  //提示框icon
      btnSrc:{ // 弹框按钮
        'err':'https://static.soyoung.com/sy-pre/shishi-1596096600726.png',
        'right':'https://static.soyoung.com/sy-pre/next-1596096600726.png',
        'noLife':'https://static.soyoung.com/sy-pre/fuhuo-1596096600726.png',
        'end':'https://static.soyoung.com/sy-pre/result-1596096600726.png'
      },
    }
  },
  props: {
    state: { //弹框状态
      type: String,  //err错误 ,right正确 ,noLife 无生命值 ,end 答题结束
      default:'err'
    },
    rightInfo: { //弹框正确状态下的展示信息
      type: String,
    }
  },
  components: {
    layer,
    Frame
  },
  created () {
    this.check(this.state)
  },
  watch: {
    state(newValue, oldValue) {
      this.check(newValue)
    }
  },
  methods: {
    check(data) {
      if(data == 'err'){
        this.iconSrc = 'https://static.soyoung.com/sy-pre/err-1596089400713.png';
        this.value = '排除一个错误选项，<br/>就离真相更近咯…'
      }else if(data == 'right'){
        this.iconSrc = 'https://static.soyoung.com/sy-pre/right-1596089400713.png';
        this.value = this.rightInfo
      }else if(data == 'noLife'){
        this.iconSrc = 'https://static.soyoung.com/sy-pre/life-1596089400713.png';
        this.value = '嘤嘤嘤，差一点就拆穿她的套路，<br/>再来一次你可以！'
      }else if(data == 'end'){
        this.iconSrc = 'https://static.soyoung.com/sy-pre/right-1596089400713.png';
        this.value = this.rightInfo
      }
    },
    leftBtn(){
      this.$emit('leftBtn',this.state)
    },
    rightBtn(){
      this.$emit('rightBtn',this.state)
    }
  },
  
}
